
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__chimstery",
  "use": "icon__chimstery-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__chimstery\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" d=\"M8.25 3a.746.746 0 0 0-.656.37.74.74 0 0 0 0 .76c.135.23.386.376.656.37H9v3.914l-5.555 9c-1.072 1.453.018 3.592 1.817 3.592H18.75c1.793 0 2.871-2.115 1.822-3.569L15 8.415V4.5h.75c.27.006.521-.14.656-.37a.74.74 0 0 0 0-.76.746.746 0 0 0-.656-.37h-7.5zm2.25 1.5h3v4.336l.111.182L15.451 12H8.55l1.95-3.164V4.5zm-2.877 9h8.754l2.959 4.799.023.023c.381.528.047 1.184-.609 1.184H5.262c-.668 0-1.002-.662-.61-1.201l.024-.024L7.623 13.5z\" /><path d=\"M0 0h24v24H0z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconChimsteryIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__chimstery" {...restProps} />
    })
  